import { ONE_PAGE_STORE_TRACKER_TYPE } from '../../../../shop/constants/tracker';
import { getInjector } from '../../utils/getInjector';

/**
 * @param {object} payload
 * @param {string} payload.option_type - The type of button that was clicked, available value: 'select_gift_option' | 'random_shipment'
 */
export const onTrackGiftCheckoutPopupClick = async (payload) => {
  const injector = await getInjector();
  const trackerService = injector.get('trackerService');

  trackerService.track({
    type: ONE_PAGE_STORE_TRACKER_TYPE.GiftCheckoutPopupClick,
    data: {
      event_category: 'Checkout',
      scope: 'one_page_store',
      option_type: payload.option_type,
    },
  });
};
